import withSharedStyles from "../../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, control, fontSize } = theme.tokens;

  return {
    section: {
      display: "flex",
      flexDirection: "column",
      gap: theme.layout.titleGap,
      minWidth: 0
    },
    head: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 16
    },
    title: {
      margin: 0,
      fontSize: fontSize.h2,
      fontWeight: 800,
      letterSpacing: "-0.01em",
      lineHeight: 1.25,
      color: color.ink,
      [theme.media.phone]: { fontSize: fontSize.mobile.h2 }
    },
    headActions: {
      display: "flex",
      alignItems: "center",
      gap: 8,
      flex: "none"
    },
    seeAll: {
      fontSize: fontSize.body,
      fontWeight: 700,
      color: color.ink,
      padding: "0 12px",
      textDecoration: "none",
      "&:hover": { color: color.brandText }
    },
    arrow: {
      appearance: "none",
      border: 0,
      cursor: "pointer",
      width: control.icon,
      height: control.icon,
      borderRadius: radius.pill,
      backgroundColor: color.field,
      color: color.ink,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": { backgroundColor: color.fieldHover },
      [theme.media.phone]: { display: "none" }
    },
    // Column widths use max(min, share): minmax() collapses to its minimum
    // for implicit columns inside a horizontal scroll container.
    row: {
      display: "grid",
      gridAutoFlow: "column",
      gap: 20,
      overflowX: "auto",
      overscrollBehaviorX: "contain",
      scrollSnapType: "x mandatory",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
      "& > *": { scrollSnapAlign: "start" }
    },
    product: {
      gridAutoColumns: "max(168px, calc((100% - 7 * 20px) / 8))",
      [theme.media.phone]: { gridAutoColumns: "148px", gap: 12 }
    },
    brand: {
      gap: 16,
      gridAutoColumns: "max(140px, calc((100% - 7 * 16px) / 8))"
    },
    banner: {
      gap: 16,
      gridAutoColumns: "max(300px, calc((100% - 32px) / 3))",
      [theme.media.phone]: { gridAutoColumns: "85%" }
    },
    // 2 per row for today's 3:1 (1025×341) banner artwork; switch callers to
    // `banner` (3 per row, 16:9) once marketing ships 1280×720 assets.
    bannerWide: {
      gap: 16,
      gridAutoColumns: "max(300px, calc((100% - 16px) / 2))",
      [theme.media.phone]: { gridAutoColumns: "88%" }
    },
    category: {
      gap: 8,
      gridAutoColumns: "112px",
      scrollSnapType: "x proximity"
    }
  };
});

export default withCustomStyles;
